import {
  buildSlottedStyles,
  getCss,
  getImageStyleJssStyle,
  getObjectFitJssStyle,
  getRatioJssStyle,
} from '../../utils';
import { TImageObjectFit, TImageStyle } from './image-utils';

export const createStyles = (): string => {
  return getCss({
    '@global': {
      ':host': {
        display: 'block',
      },
    },
  });
};

export const getSlottedCss = (
  el: HTMLElement,
  ratio: string,
  imageStyle: TImageStyle,
  objectFit: TImageObjectFit,
): string => {
  return getCss(
    buildSlottedStyles(el, {
      '& img': {
        display: 'block',
        width: '100%',
        height: 'auto',
        ...getRatioJssStyle(ratio),
        ...getObjectFitJssStyle(objectFit),
        ...getImageStyleJssStyle(imageStyle),
      },
    }),
  );
};
